import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";
import { store } from "./store/index";
import { ToastContainer } from "react-toastify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

const persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById("root"));


// Register service worker BEFORE app loads
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then((registration) => {
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.addEventListener("message", (event) => {
//     if (event.data?.type === "PLAY_SOUND") {
//       const audio = new Audio("/notification.mp3");
//       audio.play().catch((err) =>
//         console.log("Autoplay blocked in tab:", err)
//       );
//     }
//   });
// }



root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ToastContainer
          containerId="main-toast"
          newestOnTop
          theme="dark"
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          autoClose={1000}
          position="top-right"
          limit={1}
        />
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
